export default __webpack_public_path__ + "static/media/logo-pegapontos.285349f8.svg";